import { render, staticRenderFns } from "./Forgot-Password.vue?vue&type=template&id=72730ba8&scoped=true&"
import script from "./Forgot-Password.vue?vue&type=script&lang=js&"
export * from "./Forgot-Password.vue?vue&type=script&lang=js&"
import style0 from "./Forgot-Password.vue?vue&type=style&index=0&id=72730ba8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72730ba8",
  null
  
)

export default component.exports